import { API_REQUEST, apiSuccess, apiError } from "../../actions/api.action";
import { httpMethod } from "../../../enum/httpMethod";
import axios, { AxiosRequestConfig } from "axios";

const options: AxiosRequestConfig = {
  responseType: "json",
};

axios.defaults.baseURL = process.env.DBURL;

export const apiMiddleware = (store: any) => (next: any) => (action: any) => {
  // console.log(action);
  next(action);

  if (action.type.includes(API_REQUEST)) {
    const { body, url, method, feature, token } = action.meta;
    let optionsInfo = { ...options };
    if (token) optionsInfo.auth = token;

    switch (method) {
      case httpMethod.GET:
        axios
          .get(url, optionsInfo)
          .then(res => {
            if (action.callback) action.callback(res);
            store.dispatch(apiSuccess(res.data, feature));
          })
          .catch(err => {
            console.log(err);
            if (action.callback) action.callback(null, err.response);
            store.dispatch(apiError(err.response, feature));
          });
        break;

      case httpMethod.POST:
        // console.log(options.headers);
        axios
          .post(url, body, optionsInfo)
          .then(res => {
            if (action.callback) action.callback(res);
            store.dispatch(
              apiSuccess({ body: body, result: res.data.result }, feature)
            );
          })
          .catch(err => {
            console.log(err);
            if (action.callback) action.callback(null, err.response);
            store.dispatch(apiError(err.response, feature));
          });
        break;

      case httpMethod.PUT:
        axios
          .put(url, body, optionsInfo)
          .then(res => {
            if (action.callback) action.callback(res);
            store.dispatch(
              apiSuccess({ body: body, result: res.data.result }, feature)
            );
          })
          .catch(err => {
            console.log(err);
            if (action.callback) action.callback(null, err.response);
            store.dispatch(apiError(err.response, feature));
          });
        break;

      case httpMethod.DELETE:
        axios
          .delete(url, optionsInfo)
          .then(res => {
            if (action.callback) action.callback(res);
            store.dispatch(
              apiSuccess({ body: body, result: res.data.result }, feature)
            );
          })
          .catch(err => {
            if (action.callback) action.callback(null, err);
            store.dispatch(apiError(err.response, feature));
          });
        break;

      // case httpMethod.OPTIONS:
      //   axios
      //     .options(url, options)
      //     .then(res => {
      //       if (action.callback) action.callback(res); if (action.callback) action.callback(res);
      //       store.dispatch(apiSuccess(res.data, feature))
      //     })
      //     .catch(err => {
      //       if (action.callback) action.callback(null, err);
      //       store.dispatch(apiError(err.response, feature))
      //     });
      //   break;

      default:
        return;
    }
  }
};
